import { setProps } from '../props';
import initialize from '../Services/initialize';
import fetchGlobalContacts from '../../../Core/Services/fetchGlobalContacts';
import getUserSettings from '../../../Core/Services/getUserSettings';

export default (props: any) => async (dispatch) => {

  setProps(props);

  await dispatch(fetchGlobalContacts());
  await dispatch(getUserSettings());

  dispatch(initialize());

}
